import styled from 'vue-styled-components'
import colors from '@/components/kit/theme'

// use <color :background="'white'" :background-opacity="'30'" :border="'black'" :text="'black'"></color>

const componentProps = {
  background: [String, Array],
  backgroundOpacity: Number,
  border: String,
  borderRadius: String,
  text: String,
  gradient: Boolean,
  dotted: Boolean
}

const ColorDiv = styled('div', componentProps)`
  background-color: ${(props) =>
    props.backgroundOpacity == null
      ? colors.knownColor(props.background)
      : !Array.isArray(props.background)
      ? colors.knownColorWithOpacity(props.background, props.backgroundOpacity)
      : null};
  border: ${(props) => (props.border == null ? '' : '1px solid')}
    ${(props) => (props.border == null ? '' : colors.knownColor(props.border))};
  border-color: ${(props) => colors.knownColor(props.border)};
  color: ${(props) => colors.knownColor(props.text)};
  border-radius: ${(props) => props.borderRadius};

  &.with-border {
    background-color: ${(props) =>
      props.background && Array.isArray(props.background)
        ? !props.backgroundOpacity
          ? colors.knownColor(props.background[0])
          : colors.knownColorWithOpacity(
              props.background[0],
              props.backgroundOpacity
            )
        : null};
    border: 1px solid
      ${(props) =>
        props.background && Array.isArray(props.background)
          ? colors.knownColor(props.background[1])
          : null};
  }

  &.dotted {
    display: flex;
    background-color: ${(props) =>
      props.background && Array.isArray(props.background)
        ? !props.backgroundOpacity
          ? colors.knownColor(props.background[1])
          : colors.knownColorWithOpacity(
              props.background[1],
              props.backgroundOpacity
            )
        : null};
    border: 1px solid
      ${(props) =>
        props.background && Array.isArray(props.background)
          ? colors.knownColor(props.background[0])
          : null};

    > span {
      flex: 1 0 auto;
      border: 1px solid ${(props) =>
        props.background && Array.isArray(props.background)
          ? colors.knownColor(props.background[1])
          : null};
      align-self: center;
    }
  }

  &.gradient {
    background: -moz-linear-gradient(
      left,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[0])
          : props.background} 0%,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[1])
          : props.background} 50%,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[2])
          : props.background} 100%,
      transparent 100%
    );
    background: -webkit-linear-gradient(
      left,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[0])
          : props.background} 0%,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[1])
          : props.background} 50%,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[2])
          : props.background} 100%,
      transparent 100%
    );
    background: linear-gradient(
      to right,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[0])
          : props.background} 0%,
      ${(props) =>
        props.background &&
        Array.isArray(props.background) &&
        props.background.length === 3
          ? colors.knownColor(props.background[1])
          : props.background} 50%,
      ${(props) =>
        props.background && Array.isArray(props.background)
          ? colors.knownColor(props.background[2])
          : props.background} 100%,
      transparent 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(
        startColorstr='${(props) =>
          props.background && Array.isArray(props.background)
            ? colors.knownColor(props.background[0])
            : props.background}',
        endColorstr='${(props) =>
          props.background && Array.isArray(props.background)
            ? colors.knownColor(props.background[2])
            : props.background}',
        GradientType=1
      );
  }
`

export default {
  props: {
    background: [String, Array],
    backgroundOpacity: Number,
    border: String,
    borderRadius: String,
    text: String,
    gradient: Boolean,
    dotted: Boolean
  },
  render(h) {
    return (
      <ColorDiv
        class={`color${
          this.background && Array.isArray(this.background) && !this.gradient
            ? ' with-border'
            : ''
        }${this.gradient ? ' gradient' : ''}${this.dotted ? ' dotted' : ''}`}
        background={this.background}
        background-opacity={this.backgroundOpacity}
        border={this.border}
        border-radius={this.borderRadius}
        text={this.text}
      >
        {this.$slots.default}
      </ColorDiv>
    )
  }
}
